module.exports = __webpack_public_path__ + "static/media/3_Receive.25842eab.png";